module.exports = __webpack_public_path__ + "static/media/about7.b61e3e49.jpg";